import React, { useState } from "react";
import "../styles/TransactionModal.css";

const API_BASE_URL = "https://client-management-backend-8x91.onrender.com";

const EditInvestorModal = ({ investor, onClose, refresh }) => {
  const [name, setName] = useState(investor.name);
  const [phone, setPhone] = useState(investor.phone_number || "");

  const handleUpdate = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/investors/${investor.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name,
          phone_number: phone,
        }),
      });

      if (!response.ok) throw new Error("Update failed");

      alert("Investor updated successfully");
      refresh();
      onClose();
    } catch (error) {
      console.error("❌ Error updating investor:", error);
      alert("Failed to update investor.");
    }
  };

  return (
    <div className="modal">
      <div className="modal-content">
        <h3>Edit Investor</h3>

        <label>Name:</label>
        <input type="text" value={name} onChange={(e) => setName(e.target.value)} />

        <label>Phone Number:</label>
        <input
          type="tel"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          placeholder="e.g., +5926541234"
        />

        <div className="modal-buttons">
          <button className="save-btn" onClick={handleUpdate}>✔ Save</button>
          <button className="close-btn" onClick={onClose}>❌ Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default EditInvestorModal;
